export const primaryShade = 0;
